import React, { useMemo } from 'react';

import { type FWorkflowStepFragment } from '@dashboard/generated/wp/platform';
import { getWorkflowStepDefinitionType } from '@dashboard/models/WorkflowStepDefinition';

import SendEmailTemplateMessage from './SendEmailTemplateMessage';
import SendMarkdownEmailMessage from './SendMarkdownEmailMessage';
import Sleep from './Sleep';

type Props = {
  step: FWorkflowStepFragment;
};
export default function StepCard({ step }: Props) {
  const type = useMemo(() => getWorkflowStepDefinitionType(step.definition), [step.definition]);
  if (type === null) {
    return null;
  }
  switch (type) {
    case 'sendEmailTemplateMessage':
      return <SendEmailTemplateMessage step={step} />;
    case 'sendMarkdownEmailMessage':
      return <SendMarkdownEmailMessage step={step} />;
    case 'sleep':
      return <Sleep step={step} />;
  }
}
